import axios from 'axios';
import config from '../config';

export const scenarioClient = axios.create({
  baseURL: config.apiUrl,
});
